
export type SearchCourseDraftsParams = {
/**
 * 검색할 코스 제목 (부분 일치)
 */
title: string;
};
